import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ModalState {
  [key: string]: boolean; // Modal ID as key and open/close state as value
  openSidebar: boolean;
}

const initialState: ModalState = {
  openSidebar: false,
};

const modalSlice = createSlice({
  name: "modals",
  initialState,
  reducers: {
    openModal: (state, action: PayloadAction<string>) => {
      state[action.payload] = true;
    },
    closeModal: (state, action: PayloadAction<string>) => {
      state[action.payload] = false;
    },
    toggleSidebar: (state) => {
      state.openSidebar = !state.openSidebar;
    },
    closeSidebar: (state) => {
      state.openSidebar = false;
    },
  },
});

export const { openModal, closeModal, toggleSidebar, closeSidebar } =
  modalSlice.actions;
export default modalSlice.reducer;
